import { render } from "./Investment.vue?vue&type=template&id=d3ec8de0&ts=true"
import script from "./Investment.vue?vue&type=script&lang=ts"
export * from "./Investment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__